export { default } from './stockadjustmentupdate';
